import SecondaryFooter from '../SecondaryFooter/SecondaryFooter';
import Text from '../Text/Text';
import StyledProcessingContainer from './StyledProcessingContainer';
import CheckIcon from '../Icons/CheckIcon';
import StyledIcon from '../Icons/StyledIcon';

interface ProcessingContainerProps {
  title: string;
  items: Array<{ text: string; isCompleted: boolean }>;
}

const ProcessingContainer = ({
  title,
  items,
}: ProcessingContainerProps): JSX.Element => {
  return (
    <>
      <StyledProcessingContainer>
        <div>
          <Text type="h2">
            {title}
            <span className="dots"></span>
          </Text>
          <ul>
            {items.map((item, idx) => (
              <li key={idx}>
                <StyledIcon>
                  <CheckIcon
                    fill={
                      item.isCompleted
                        ? 'var(--completed-color)'
                        : 'var(--processing-color)'
                    }
                  />
                  <Text type="subtitle2">{item.text}</Text>
                </StyledIcon>
              </li>
            ))}
          </ul>
        </div>
      </StyledProcessingContainer>
      <SecondaryFooter justifyContent="flex-end" />
    </>
  );
};

export default ProcessingContainer;
